export default import.meta.ROLLDOWN_FILE_URL_e$G5gBiiU8eppUgrm1MQ4A